var map = {
	"./data": "0f65",
	"./data.json": "0f65",
	"./logo_BRI_1.png": "3b7c",
	"./logo_BRI_2.png": "511e",
	"./logo_KAI-Pay.png": "b5b8",
	"./logo_NU.jpg": "65d9",
	"./logo_NU.png": "f19a",
	"./logo_NU_cdr.jpg": "50a4",
	"./logo_NU_muslimat.jpeg": "9fdd",
	"./logo_NU_muslimat.png": "5261",
	"./logo_alfamart.png": "5030",
	"./logo_balai_pustaka.jpeg": "a13e",
	"./logo_balai_pustaka.png": "0c48",
	"./logo_bank_bjb_syariah.png": "6017",
	"./logo_bank_bni.png": "0926",
	"./logo_bank_muamalat.png": "2bd1",
	"./logo_bayer.png": "6964",
	"./logo_bpjsk.png": "eab7",
	"./logo_bpjstk1.png": "7c0e",
	"./logo_bpjstk2.png": "4806",
	"./logo_btn.png": "f20f",
	"./logo_bukalapak.png": "5f84",
	"./logo_denstv.png": "80c0",
	"./logo_dukcapil.png": "4ef4",
	"./logo_efishery.png": "8f7f",
	"./logo_excelso.png": "c1c8",
	"./logo_garuda_indonesia.png": "3e22",
	"./logo_gluu_bizconnect_red.png": "bb64",
	"./logo_grosirone.png": "adf5",
	"./logo_holcim.png": "3fb0",
	"./logo_homecredit.png": "f655",
	"./logo_indofarma.png": "b31d",
	"./logo_indogold1.png": "b7ca",
	"./logo_indogold2.png": "43a1",
	"./logo_indomaret.png": "f74d",
	"./logo_indosat.png": "e61e",
	"./logo_inkoppas.png": "04fa",
	"./logo_irma.png": "63d1",
	"./logo_koperasi.png": "9abb",
	"./logo_kredivo.png": "3715",
	"./logo_mandiri_taspen.png": "52e9",
	"./logo_mastercard1.png": "fae3",
	"./logo_mastercard2.png": "6de0",
	"./logo_maxim.png": "bc02",
	"./logo_moneygram1.png": "352c",
	"./logo_moneygram2.png": "829e",
	"./logo_moneygram3.svg": "41a6",
	"./logo_nestle.png": "9dea",
	"./logo_philip_morris.png": "c310",
	"./logo_pos_indonesia1.png": "613a",
	"./logo_pos_indonesia2.png": "8d6f",
	"./logo_reliance_biru.png": "da49",
	"./logo_semen_indonesia.png": "ae9a",
	"./logo_sicepat.png": "1d90",
	"./logo_sicepat.svg": "eafb",
	"./logo_sig.svg": "89cb",
	"./logo_socmed.png": "c038",
	"./logo_starbucks1.png": "0d50",
	"./logo_starbucks2.png": "df61",
	"./logo_trace1.png": "f3c7",
	"./logo_trace2.png": "16fe",
	"./logo_tron_ungu.png": "02c7",
	"./logo_uangme.png": "8226",
	"./logo_unilever.png": "8056",
	"./logo_western_union1.png": "058c",
	"./logo_western_union2.png": "83c8",
	"./logo_western_union3.png": "5ae1",
	"./logo_xl.png": "a7a7",
	"./logo_xpress_money.png": "2207"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60aa";